// export const BASE_URL = "http://192.168.0.2:8001";
// export const IMAGE_URL = BASE_URL;


export const BASE_URL = "https://admin.denny.co.za";
export const IMAGE_URL = BASE_URL + "/public";
export const FRONTEND_URL = "https://denny.co.za";
